import React , {useEffect, useState} from 'react'
import {  Box, Container, Stack, Tooltip, Typography, Pagination,
    Link, Button, Modal } from '@mui/material'
import CloseButton from './CloseButton'
 import * as helpers from '../utils/helpers'
 import * as API from '../utils/APICalls'

const ReviewEventModal = ({
  reviewEventModalOpen, setReviewEventModalOpen,
  setSelectedEvent,selectedEvent,fetchBookings}) => {
  // const e = selectedEvent

    const [ e, setE ] = useState()
    useEffect(()=>{
      setE(selectedEvent)
    },[selectedEvent])
    const price = helpers.formattedShowPriceString(selectedEvent)

     const handleConfirmEvent = async (e) => {
      
      try{
        const res = await API.updateBooking({
          ...selectedEvent,
          isConfirmed:true, 
          status:'confirmed'})
          if (res)
            {
              setSelectedEvent(res)
              setReviewEventModalOpen(false)
              fetchBookings()
            }       
      }catch(err){console.log('Error updating event status',err)}
    
      };
      

    const handleCancelEvent  = async (e) => {
      
      try{
        const res = await API.updateBooking({...selectedEvent,
          isConfirmed:false, 
          status:'canceled'})
          if (res)
            {
              setSelectedEvent(res)
              setReviewEventModalOpen(false)
              fetchBookings()
            }       
      }catch(err){console.log('Error updating event status',err)}
    
      };

      const handleHideEvent  = async (e) => {
      
        try{
          const res = await API.updateBooking({...selectedEvent,
            isConfirmed: false, 
            status:'hidden'})
            if (res)
              {
                setSelectedEvent(res)
                setReviewEventModalOpen(false)
                fetchBookings()
              }        
}catch(err){console.log('Error updating event status',err)}
      
        };

  return (
    <>
           <Modal 
               open={reviewEventModalOpen}
               onClose={()=>setReviewEventModalOpen(!reviewEventModalOpen)}
               >
               <Container sx={{zIndex:999}}>
                   <Box sx={{ 
                       display:'flex',
                       flexDirection:'column',
                       position: 'absolute',
                       top: '50%',
                       left: '50%',
                       transform: 'translate(-50%, -50%)',
                       width: '100%',
                      
                       height:'100%',
                       backgroundColor:  'rgba( 0, 0, 0, 0.1)',
                       backdropFilter:'blur(10px)',
                       borderRadius:'10px',
                       border:'2px solid #000',
                       fontFamily: 'Gilroy, sans-serif',
                       justifyContent:'center',
                       textAlign:'center',
                       alignItems:'center',
                       gap:'0.5rem',
                       padding:'0.5rem',
                       color:'#FFF',
                       
                       }}>
                           <Box sx={{position:'absolute', top:'0.5rem', right:'0.5rem'}}>
                               <CloseButton func={setReviewEventModalOpen} val={reviewEventModalOpen}
                               />
                           </Box>
                            <Box sx={{
                               position:'relative',
                                   display:'flex',flexDirection:'column', 
                                   backgroundImage: 'url("/assets/BodyBG2.png")',
                                   // backgroundImage:'url("/assets/Gradient_01_Frame2.png")',
                                   backgroundAttachment: 'cover',
                                   backgroundRepeat: 'no-repeat',
                                   // background:'#000',
                                   boxShadow:'0 0 10px 5px rgba(0, 255, 0 ,0.5)',
                                  //  overflow:'hidden',
                                  //  overflowY:'scroll',
                                   width:'80%',
                                   minWidth:'340px', minHeight:'550px', 
                                   height:'80%',
                                   gap:'0.5rem', color:'#00FF00', borderRadius:'5px'}}>
                               <Box sx={{position:'sticky',top:0, left:0, zIndex:999999999,width:'100%', height:'1.5rem',background:'#F6F6F6'}}>
                            
                                   <Typography sx={{color: '#858585'}} className='blink'>
                                      <b>Event Details</b> 
                                   </Typography>
                                   </Box>
                                  {/* {e?.location?.url &&  */}
                         <Button 
                         size='small'
                         variant='contained' 
                         sx={{position:'absolute',right:'0.5rem', top:'2rem'}}
                        //  disabled={!e?.location?.url}
                         onClick={((e)=>{
                            e.preventDefault()
                            window.open(e?.location?.url)
                         })}>
                                Visit Venue Listing
                            </Button>
                            {/* } */}
                           <Stack 
                            className='center'
                            sx={{position:'relative',
                               height:'100%',width:'100%',
                               padding:'0.5rem',
                               // flex:1
                                   margin:'auto', 
                                   gap:'0.5rem',
                                   color:'#FFF',
                                   alignItems: 'center',
                                   alignContent:'center',
                                   textAlign:'left',
                                   overflow:'hidden',
                                   overflowY:'scroll',
                                   marginBottom:'4rem'
                                  //  justifyContent:'start'
                               }} >
   
                         <h1>{e?.event_name}</h1>
                         {e?.date && <p>{helpers.formatedEventDate(e?.date)}</p>}
                         <h2>@ {e?.location?.venue}</h2>
                         {e?.event_type && <span>Type: <b>{e?.event_type}</b></span>}
                         <p>(cap: {e?.location?.capacity})</p>
                         <p>{e?.location?.city}, {e?.location?.state} </p>

                         <p>Doors at: {helpers.convertMilitaryToAmPm(e?.event_time)}</p>
                         {e?.door_age}
                         <span>
                         <p>Set time: {helpers.convertMilitaryToAmPm(e?.set_time)}</p>
                         <p>Set length: {e?.set_length}</p>
                         <b>Cover:</b>
                         {/* {(!e?.price?.adv && !e?.price?.door) && <p>TBA</p>}   */}
                         {/* {price} */}
                         </span>
                         {e?.price?.adv && <p>Advance: {e?.price?.adv.toLowerCase() !=='free'?'$':''}{e?.price?.adv}</p>}
                         {e?.price?.door && <p>Door: {e?.price?.door.toLowerCase() !=='free'?'$':''}{e?.price?.door}</p>}
                         {/* {e?.other_acts?.toLowerCase() !== 'na' &&<> */}
                         <span>
                          <b>Other Acts:</b>
                          {e?.other_acts}
                         </span>
                         
                         {/* </>} */}
                         {e?.host && <h4>hosted by: <b>{e?.host}</b></h4>}
                         {e?.details && <div>
                            Details: <p>
                                {e?.details}
                            </p>
                            </div>}
                            {e?.sponsors && <span>Sponsors: <b>{e?.sponsors}</b></span>}
                            {e?.budget && <span>Budget: <b>{e?.budget}</b></span>}
                            {e?.tech_needs && <span>Tech Needs: <b>{e?.tech_needs}</b></span>}
                            {e?.contract_needs && <span>Contract Needs: <b>{e?.contract_needs}</b></span>}
                            {e?.status && <span>Status: <b>{e?.status}</b></span>}
                           </Stack>
                           <Box sx={{
      margin: '1rem auto',
      flexWrap:'wrap',
      height:'fit-content',
      // padding:'0.5rem',
// backgroundColor:'rgba( 255, 255, 255, 0.5)',
              display:'flex', width:'100%', justifyContent:'space-between'}}>

                            <Button
                            size='small'
                              variant='contained' 
                              sx={{margin:'auto',width:'75px'}}
                              disabled={!e?.isConfirmed}
                              onClick={handleCancelEvent}>
                                      Cancel
                            </Button>
                            <Button 
                            size='small'
                            variant='contained' 
                              sx={{margin:'auto',width:'75px'}}
                              disabled={!e?.isConfirmed}
                              onClick={handleHideEvent}>
                                      Hide
                            </Button>
                            <Button 
                            size='small'
                            variant='contained' 
                              sx={{margin:'auto',width:'75px'}}
                              disabled={e?.isConfirmed}
                              onClick={handleConfirmEvent}>
                                      Confirm
                            </Button>
</Box>
                     </Box>
            
                       </Box>                   
               </Container>
           </Modal>
           
       </>
  )
}

export default ReviewEventModal